/**
 * @generated SignedSource<<bc0740e7cf076438c2c03b889cd1296e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PublishDialog_documentNameQuery$variables = {
  id: string;
};
export type PublishDialog_documentNameQuery$data = {
  readonly document: {
    readonly canRename?: {
      readonly value: boolean;
    };
    readonly id: string;
    readonly name?: string;
  } | null;
};
export type PublishDialog_documentNameQuery = {
  response: PublishDialog_documentNameQuery$data;
  variables: PublishDialog_documentNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canRename",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublishDialog_documentNameQuery",
    "selections": [
      {
        "alias": "document",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishDialog_documentNameQuery",
    "selections": [
      {
        "alias": "document",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c2c47d218522a8ce889f0bc870336ce9",
    "id": null,
    "metadata": {},
    "name": "PublishDialog_documentNameQuery",
    "operationKind": "query",
    "text": "query PublishDialog_documentNameQuery(\n  $id: ID!\n) {\n  document: node(id: $id) {\n    __typename\n    id\n    ... on FolderNodeInterface {\n      __isFolderNodeInterface: __typename\n      name\n      canRename {\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6eb065b680022d4afbd68814c17e8c1";

export default node;
